import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "select-value"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "reply-select__section-title" }, "EXISTING", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "reply-select__section-title mb-1"
}

import { computed, ref } from 'vue';
import { useRepliesStore } from '@/stores/replies';
import VAuthInput from './VAuthInput.vue';
import VSelect from './VSelect.vue';
import AddIcon from './icons/other/AddIcon.vue';
import SearchIcon from './icons/other/SearchIcon.vue';
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'VReplySetSelect',
  props: {
    modelValue: null
  },
  emits: [ "update:modelValue" ],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: number | null }

const repliesStore = useRepliesStore()




const sourceReplySet = useVModel(props, "modelValue", emit)

const searchValue = ref("")

const items = computed(() => {
  if (!searchValue.value) return repliesStore.replies
  const val = searchValue.value.toLowerCase()
  return repliesStore.replies.filter(item => item.name.toLowerCase().startsWith(val))
})

const hasItems = repliesStore.replies.length > 0

const vSelectRef = ref<any>()
const setReplySet = (value: number) => {
  sourceReplySet.value = value
  vSelectRef.value.close()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VSelect, {
    ref_key: "vSelectRef",
    ref: vSelectRef,
    class: "dialog-select",
    placeholder: "Choose Replies set",
    "mobile-close": ""
  }, {
    default: _withCtx(() => [
      (_unref(sourceReplySet) !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(sourceReplySet) === -1? "New reply set": _unref(repliesStore).replies.find(item => item.id === _unref(sourceReplySet))?.name), 1))
        : _createCommentVNode("", true)
    ]),
    top: _withCtx(() => [
      hasItems
        ? (_openBlock(), _createBlock(VAuthInput, {
            key: 0,
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
            autofocus: "",
            icon: SearchIcon,
            placeholder: "Search",
            class: "light reply-select__search",
            clearable: ""
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (!searchValue.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "reply-select__add",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setReplySet(-1)))
          }, [
            _createVNode(AddIcon),
            _createTextVNode(" New Replies Set ")
          ]))
        : _createCommentVNode("", true),
      hasItems
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (reply) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "reply-select__item",
                onClick: ($event: any) => (setReplySet(reply.id))
              }, _toDisplayString(reply.name), 9, _hoisted_3))
            }), 256)),
            (_unref(items).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Nothing found"))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})